export const track = (event, params = {}) => {
  window.dataLayer = window.dataLayer || [];
  window.dataLayer.push({ event, ...params });
};

export const API = `${process.env.REACT_APP_BACKEND_URL}/api`;
